import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateAgo',
})
export class DateAgoPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let seconds = Math.floor(((Date.now()) - value) / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    let days = Math.floor(hours / 24);
    let result;
    if (days > 365) {
      result = Math.floor(days / 365) + " Years";
      const yr: any = Math.floor(days / 365);
      result = yr + " Year" + (yr > 1 ? 's' : '');
    } else if (days >= 30) {
      const month: any = Math.floor(days / 30);
      result = month + " Month" + (month > 1 ? 's' : '');
    } else if (days >= 7) {
      const week: any = Math.floor(days / 7);
      result = week + " Week" + (week > 1 ? 's' : '');
    } else if (days >= 1) {
      const day: any = Math.floor(days / 1);
      result = day + " Day" + (day > 1 ? 's' : '');
    } else if (hours >= 1) {
      result = hours + " Hour" + (hours > 1 ? 's' : '');
    } else if (minutes >= 1) {
      result = minutes + " Minute" + (minutes > 1 ? "s" : "");
    } else {
      result = "Now";
    }
    return result == "Now" ? result : result + " ago";
  }

}
